export const environment = {
  production: true,
  cdc: {
    apiKey: {
      'hisense-rs': '4_hFWpTiP0RgrYvpgXpVbL5w',
      'hisense-si': '4_ETUwFahM6WG0wFJVMiOXwg',
      'hisense-hu': '4_G4j-XSr8tCuLblxNAQFd-w',
      'hisense-pl': '4_hq0nm9BiXOGDeMWlWvKvdQ',
      'hisense-sk': '4_hkEGdwpJ8cnGqYIYAtKqDw',
      'hisense-cz': '4_leQjctVkcH8DoeFCf_1Wvw',
      'hisense-hr': '4_phqV9uUEvdaHOkB9CWbfhw',
      // "hisense-int": "",
      'hisense-uk': '4_aJxCgiytjRsui94HpFkWvw',
      'hisense-ba': '4_ASXelTNwBNfW7ogJ5OZKGA',
      'hisense-ua': '4_jnGp49YojMIQyWElzIWVKA',
      // "hisense-md": "",
      'hisense-ro': '4_zrpxxswEl1E2OyjIHSfh-A',
      'hisense-bg': '4_65VS1qln5nGsKtqHcRUEBg',
      // "hisense-nl": "",
      // "hisense-be": "",
      'hisense-at': '4_JnjHpR5ahmdvsnEGkdai1w',
      'hisense-mk': '4_Wrl1kJVMLX4uLqpwLSRGyA',
      // "hisense-ee": "",
      // "hisense-lt": "",
      // "hisense-lv": "",
      'hisense-it': '4_EFcu69OC5AdEoYSND-ZpvA',
      // "hisense-me": "",
      'hisense-al': '4_77M9GCNY0OCE08jKDIkqAg',
      'hisense-dk': '4_VmycYzlzB6blVTP3iEqnpQ',
      // "hisense-ie": "",
      'hisense-de': '4_7lzrb1NjyT1CqcHscl3S0w',
      'hisense-kz': '4_CK2JEwrWvMtR-ZKRDADhFQ',
      'hisense-no': '4_PpQm6n-JyccTm6iB7eWq1A',
      'hisense-se': '4_eTNTf-d7n6Sf0FGgc8ym8g',
      'hisense-fi': '4_-cOqfVu2_dnmXh1RDQ51eA',
      // 'hisense-gr': "",
      // 'hisense-fr': "",
    },
  },
  noAddToCart: {
    showInstead: {
      'hisense-rs': {
        dealerLocator: true,
      },
      'hisense-si': {
        dealerLocator: false,
      },
      'hisense-hu': {
        dealerLocator: false,
      },
      'hisense-pl': {
        dealerLocator: true,
      },
      'hisense-sk': {
        dealerLocator: false,
      },
      'hisense-cz': {
        dealerLocator: false,
      },
      'hisense-hr': {
        dealerLocator: false,
      },
      'hisense-int': {
        dealerLocator: false,
      },
      'hisense-uk': {
        dealerLocator: false,
      },
      'hisense-ba': {
        dealerLocator: false,
      },
      'hisense-ua': {
        dealerLocator: true,
      },
      'hisense-md': {
        dealerLocator: true,
      },
      'hisense-ro': {
        dealerLocator: true,
      },
      'hisense-bg': {
        dealerLocator: false,
      },
      'hisense-nl': {
        dealerLocator: true,
      },
      'hisense-be': {
        dealerLocator: true,
      },
      'hisense-at': {
        dealerLocator: false,
      },
      'hisense-mk': {
        dealerLocator: false,
      },
      'hisense-ee': {
        dealerLocator: true,
      },
      'hisense-lt': {
        dealerLocator: false,
      },
      'hisense-lv': {
        dealerLocator: false,
      },
      'hisense-it': {
        dealerLocator: false,
      },
      'hisense-me': {
        dealerLocator: false,
      },
      'hisense-al': {
        dealerLocator: false,
      },
      'hisense-dk': {
        dealerLocator: false,
      },
      'hisense-ie': {
        dealerLocator: false,
      },
      'hisense-de': {
        dealerLocator: false,
      },
      'hisense-kz': {
        dealerLocator: false,
      },
      'hisense-no': {
        dealerLocator: false,
      },
      'hisense-se': {
        dealerLocator: false,
      },
      'hisense-fi': {
        dealerLocator: false,
      },
      'hisense-gr': {
        dealerLocator: false,
      },
      'hisense-fr': {
        dealerLocator: false,
      },
    },
  },
  eShop: {
    showAddToCartButtonAndCartMenuNode: {
      'hisense-rs': true,
      'hisense-si': true,
      'hisense-hu': true,
      'hisense-pl': false,
      'hisense-sk': false,
      'hisense-cz': true,
      'hisense-hr': true,
      'hisense-int': false,
      'hisense-uk': true,
      'hisense-ba': true,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': true,
      'hisense-mk': true,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': false,
      'hisense-me': false,
      'hisense-al': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': true,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    showMyAccountDropdown: {
      'hisense-rs': true,
      'hisense-si': true,
      'hisense-hu': true,
      'hisense-pl': true,
      'hisense-sk': true,
      'hisense-cz': true,
      'hisense-hr': true,
      'hisense-int': false,
      'hisense-uk': true,
      'hisense-ba': true,
      'hisense-ua': true,
      'hisense-md': false,
      'hisense-ro': true,
      'hisense-bg': true,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': true,
      'hisense-mk': true,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': true,
      'hisense-me': false,
      'hisense-al': true,
      'hisense-dk': true,
      'hisense-ie': false,
      'hisense-de': true,
      'hisense-kz': true,
      'hisense-no': true,
      'hisense-se': true,
      'hisense-fi': true,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    showOrderHistoryMenuNode: {
      'hisense-rs': true,
      'hisense-si': true,
      'hisense-hu': true,
      'hisense-pl': false,
      'hisense-sk': false,
      'hisense-cz': true,
      'hisense-hr': true,
      'hisense-int': false,
      'hisense-uk': true,
      'hisense-ba': true,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': true,
      'hisense-mk': true,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': false,
      'hisense-me': false,
      'hisense-al': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': true,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    showLufcMembershipMenuNode: {
      'hisense-rs': false,
      'hisense-si': false,
      'hisense-hu': false,
      'hisense-pl': false,
      'hisense-sk': false,
      'hisense-cz': false,
      'hisense-hr': false,
      'hisense-int': false,
      'hisense-uk': true,
      'hisense-ba': false,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': false,
      'hisense-mk': false,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': false,
      'hisense-me': false,
      'hisense-al': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': false,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    // TODO: add tax format (order-summary.component - calculateTaxFromPrice)
    showPrice: {
      'hisense-rs': true,
      'hisense-si': true,
      'hisense-hu': true,
      'hisense-pl': false,
      'hisense-sk': true,
      'hisense-cz': true,
      'hisense-hr': true,
      'hisense-int': false,
      'hisense-uk': true,
      'hisense-ba': true,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': true,
      'hisense-be': true,
      'hisense-at': true,
      'hisense-mk': true,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': false,
      'hisense-me': true,
      'hisense-al': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': true,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    showFullPriceDescription: {
      'hisense-rs': false,
      'hisense-si': false,
      'hisense-hu': false,
      'hisense-pl': false,
      'hisense-sk': false,
      'hisense-cz': true,
      'hisense-hr': true,
      'hisense-int': false,
      'hisense-uk': false,
      'hisense-ba': false,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': false,
      'hisense-mk': false,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': false,
      'hisense-me': true,
      'hisense-al': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': true,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    showStockTrafficLight: {
      'hisense-rs': true,
      'hisense-si': true,
      'hisense-hu': true,
      'hisense-pl': false,
      'hisense-sk': false,
      'hisense-cz': true,
      'hisense-hr': true,
      'hisense-int': false,
      'hisense-uk': true,
      'hisense-ba': false,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': true,
      'hisense-mk': true,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': false,
      'hisense-me': false,
      'hisense-al': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': true,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    showStock: {
      'hisense-rs': false,
      'hisense-si': false,
      'hisense-hu': false,
      'hisense-pl': false,
      'hisense-sk': false,
      'hisense-cz': false,
      'hisense-hr': false,
      'hisense-int': false,
      'hisense-uk': false,
      'hisense-ba': false,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': false,
      'hisense-mk': false,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': false,
      'hisense-me': false,
      'hisense-al': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': false,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    showDeliveryInfo: {
      'hisense-rs': true,
      'hisense-si': true,
      'hisense-hu': true,
      'hisense-pl': false,
      'hisense-sk': false,
      'hisense-cz': true,
      'hisense-hr': true,
      'hisense-int': false,
      'hisense-uk': false,
      'hisense-ba': true,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': true,
      'hisense-mk': true,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': false,
      'hisense-me': false,
      'hisense-al': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': true,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    showDeliveryInfoOnListings: {
      'hisense-rs': true,
      'hisense-si': true,
      'hisense-hu': true,
      'hisense-pl': false,
      'hisense-sk': false,
      'hisense-cz': true,
      'hisense-hr': true,
      'hisense-int': false,
      'hisense-uk': false,
      'hisense-ba': true,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': true,
      'hisense-mk': true,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': false,
      'hisense-me': false,
      'hisense-al': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': true,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    showCurrencyOnRightCart: {
      'hisense-rs': false,
      'hisense-si': false,
      'hisense-hu': false,
      'hisense-pl': false,
      'hisense-sk': false,
      'hisense-cz': false,
      'hisense-hr': false,
      'hisense-int': false,
      'hisense-uk': false,
      'hisense-ba': true,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': false,
      'hisense-mk': false,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': false,
      'hisense-me': false,
      'hisense-al': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': false,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    showOrderKeyFeatures: {
      'hisense-rs': ['freeDelivery', 'freeReturn', 'safePayment'],
      'hisense-si': ['freeDelivery', 'freeReturn', 'safePayment'],
      'hisense-hu': ['freeDelivery', 'freeReturn', 'safePayment'],
      'hisense-pl': [],
      'hisense-sk': [],
      'hisense-cz': ['freeDelivery', 'freeReturn', 'safePayment'],
      'hisense-hr': [
        'freeDelivery',
        'freeReturn',
        'safePayment',
        'warranty',
      ],
      'hisense-int': [],
      'hisense-uk': [
        'freeDelivery',
        'freeReturn',
        'safePayment',
        'warranty',
      ],
      'hisense-ba': ['freeDelivery', 'freeReturn', 'safePayment'],
      'hisense-ua': [],
      'hisense-md': [],
      'hisense-ro': [],
      'hisense-bg': [],
      'hisense-nl': [],
      'hisense-be': [],
      'hisense-at': ['freeDelivery', 'freeReturn', 'safePayment'],
      'hisense-mk': [
        'freeDelivery',
        'freeReturn',
        'safePayment',
        'warranty',
      ],
      'hisense-ee': [],
      'hisense-lt': [],
      'hisense-lv': [],
      'hisense-it': [],
      'hisense-me': [],
      'hisense-al': [],
      'hisense-dk': [],
      'hisense-ie': [],
      'hisense-de': [
        'freeDelivery',
        'freeReturn',
        'safePayment',
        'warranty',
      ],
      'hisense-kz': [],
      'hisense-no': [],
      'hisense-se': [],
      'hisense-fi': [],
      'hisense-gr': [],
      'hisense-fr': [],
    },
    showPercentagePriceDifference: {
      'hisense-rs': false,
      'hisense-si': false,
      'hisense-hu': false,
      'hisense-pl': false,
      'hisense-sk': false,
      'hisense-cz': false,
      'hisense-hr': false,
      'hisense-int': false,
      'hisense-uk': false,
      'hisense-ba': false,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': false,
      'hisense-mk': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': true,
      'hisense-kz': false,
      'hisense-fr': false,
    },
    trustPilot: {
      'hisense-rs': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-si': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-hu': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-pl': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-sk': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-cz': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-hr': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-int': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-uk': {
        show: true,
        dataLocale: 'en-GB',
        businessUnitId: '5a999e24e08b8d00016b8b50',
        templateId: '53aa8807dec7e10d38f59f32',
        url: 'https://uk.trustpilot.com/review/hisense.co.uk',
      },
      'hisense-ba': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-ua': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-md': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-ro': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-bg': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-nl': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-be': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-at': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-mk': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-ee': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-lt': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-lv': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-it': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-me': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-al': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-dk': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-ie': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-de': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-kz': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-no': {
        show: true,
        dataLocale: 'nb-NO',
        businessUnitId: '663b696a5b196ea6a78547b4',
        templateId: '53aa8807dec7e10d38f59f32',
        url: 'https://no.trustpilot.com/review/no.hisense.com',
      },
      'hisense-se': {
        show: true,
        dataLocale: 'sv-SE',
        businessUnitId: '655a379721ebbbcdd22d5fe0',
        templateId: '53aa8807dec7e10d38f59f32',
        url: 'https://se.trustpilot.com/review/se.hisense.com',
      },
      'hisense-fi': {
        show: true,
        dataLocale: 'fi-FI',
        businessUnitId: '66e19e7ca666ab140e2d0350',
        templateId: '53aa8807dec7e10d38f59f32',
        url: 'https://fi.trustpilot.com/review/fin.hisense.com',
      },
      'hisense-gr': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
      'hisense-fr': {
        show: false,
        dataLocale: '',
        businessUnitId: '',
        templateId: '',
        url: '',
      },
    },
  },
  subscriptions: {
    'hisense-rs': true,
    'hisense-si': true,
    'hisense-hu': true,
    'hisense-pl': true,
    'hisense-sk': true,
    'hisense-cz': true,
    'hisense-hr': true,
    'hisense-int': false,
    'hisense-uk': true,
    'hisense-ba': true,
    'hisense-ua': true,
    'hisense-md': true,
    'hisense-ro': true,
    'hisense-bg': true,
    'hisense-nl': true,
    'hisense-be': true,
    'hisense-at': true,
    'hisense-mk': true,
    'hisense-ee': false,
    'hisense-lt': false,
    'hisense-lv': false,
    'hisense-it': true,
    'hisense-me': false,
    'hisense-al': true,
    'hisense-dk': true,
    'hisense-ie': true,
    'hisense-de': true,
    'hisense-kz': true,
    'hisense-no': true,
    'hisense-se': true,
    'hisense-fi': true,
    'hisense-gr': false,
    'hisense-fr': true,
  },
  reviews: {
    show: {
      'hisense-rs': true,
      'hisense-si': true,
      'hisense-hu': true,
      'hisense-pl': true,
      'hisense-sk': true,
      'hisense-cz': true,
      'hisense-hr': true,
      'hisense-int': false,
      'hisense-uk': true,
      'hisense-ba': true,
      'hisense-ua': true,
      'hisense-md': false,
      'hisense-ro': true,
      'hisense-bg': true,
      'hisense-nl': true,
      'hisense-be': true,
      'hisense-at': true,
      'hisense-mk': true,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': true,
      'hisense-me': false,
      'hisense-al': true,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': true,
      'hisense-kz': true,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': true,
    },
    showAwardGame: {
      'hisense-rs': false,
      'hisense-si': true,
      'hisense-hu': true,
      'hisense-pl': true,
      'hisense-sk': true,
      'hisense-cz': false,
      'hisense-hr': true,
      'hisense-int': true,
      'hisense-uk': false,
      'hisense-ba': false,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': false,
      'hisense-mk': false,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': false,
      'hisense-me': false,
      'hisense-al': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': false,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    bvEnabled: {
      'hisense-rs': false,
      'hisense-si': false,
      'hisense-hu': false,
      'hisense-pl': false,
      'hisense-sk': false,
      'hisense-cz': false,
      'hisense-hr': false,
      'hisense-int': false,
      'hisense-uk': true,
      'hisense-ba': false,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': false,
      'hisense-mk': false,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': false,
      'hisense-me': false,
      'hisense-al': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': true,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': true,
    },
    kieskeurigReviewsEnabled: {
      'hisense-rs': false,
      'hisense-si': false,
      'hisense-hu': false,
      'hisense-pl': false,
      'hisense-sk': false,
      'hisense-cz': false,
      'hisense-hr': false,
      'hisense-int': false,
      'hisense-uk': false,
      'hisense-ba': false,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': true,
      'hisense-be': true,
      'hisense-at': false,
      'hisense-mk': false,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': false,
      'hisense-me': false,
      'hisense-al': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': false,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    kieskeurigReviewsToken: {
      'hisense-rs': '',
      'hisense-si': '',
      'hisense-hu': '',
      'hisense-pl': '',
      'hisense-sk': '',
      'hisense-cz': '',
      'hisense-hr': '',
      'hisense-int': '',
      'hisense-uk': '',
      'hisense-ba': '',
      'hisense-ua': '',
      'hisense-md': '',
      'hisense-ro': '',
      'hisense-bg': '',
      'hisense-nl': '86e82c9c-c12d-4fdf-ab85-d8421ce46b28',
      'hisense-be': '86e82c9c-c12d-4fdf-ab85-d8421ce46b28',
      'hisense-at': '',
      'hisense-mk': '',
      'hisense-ee': '',
      'hisense-lt': '',
      'hisense-lv': '',
      'hisense-it': '',
      'hisense-me': '',
      'hisense-al': '',
      'hisense-dk': '',
      'hisense-ie': '',
      'hisense-de': '',
      'hisense-kz': '',
      'hisense-no': '',
      'hisense-se': '',
      'hisense-fi': '',
      'hisense-gr': '',
      'hisense-fr': '',
    },
  },
  formValidators: {
    phoneNumber: {
      'hisense-rs': '[0-9 ]{7,15}|[+]{1}[3]{1}[8]{1}[1]{1}[6]{1}[ ]{0,1}[0-9 ]{7,15}',
      'hisense-si': '[+]?[0-9]{11}|[0]{2}[0-9]{11}|[0-9]{9}',
      'hisense-hu':
        '[0-9]{9,11}|[0]{2}[0-9]{10,11}|[0-9]{6,7}|[+]{1}[0-9]{10,11}|[0-9]{2}[-]{1}[0-9]{3}[-]{1}[0-9]{2}[-]{1}[0-9]{2}|[+]?[0-9]{2}[-]{1}[0-9]{2}[-]{1}[0-9]{3}[-]{1}[0-9]{2}[-]{1}[0-9]{2}|[+]?[0-9]{2}[-]{1}[0-9]{1}[-]{1}[0-9]{3}[-]{1}[0-9]{2}[-]{1}[0-9]{2}|[0-9]{3}[-]{1}[0-9]{2}[-]{1}[0-9]{2}|[0-9]{2}[-]{1}[0-9]{2}[-]{1}[0-9]{2}[-]{1}[0-9]{3}[-]{1}[0-9]{2}[-]{1}[0-9]{2}',
      'hisense-pl': '[0-9]{3}[ ]{0,1}[0-9]{3}[ ]{0,1}[0-9]{3}|[0-9]{2}[ ]{0,1}[0-9]{4}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}',
      'hisense-sk':
        '[+]?[0-9]{11}|[0]{2}[0-9]{11}|[0-9]{3}[ ]{0,1}[0-9]{3}[ ]{0,1}[0-9]{3}|[+]?[0-9]{12}|[0]{2}[0-9]{12}|[0-9]{10}',
      'hisense-cz':
        '[+]?[ ]{0,1}[0-9]{3}[ ]{0,1}[0-9]{2,3}[ ]{0,1}[0-9]{3}[ ]{0,1}[0-9]{3}|[0]{2}[ ]{0,1}[0-9]{3}[ ]{0,1}[0-9]{2,3}[ ]{0,1}[0-9]{3}[ ]{0,1}[0-9]{3}|[0-9]{3}[ ]{0,1}[0-9]{3}[ ]{0,1}[0-9]{3}',
      'hisense-hr': '[+]{1}[0-9]{11,12}|[0-9]{9,11}',
      'hisense-uk': '[+]?[0-9]{11}|[+]{1}[4]{2}[0-9]{10}|[0-9]{11}|[0]{2}[4]{2}[0-9]{10}|[0-9]{9}',
      'hisense-ba': '[+]{1}[0-9]{3}[ ]{0,1}[0-9]{8,9}|[0-9]{3}[ ]{0,1}[0-9]{6,7}|[0-9]{2}[ ]{0,1}[0-9]{6}',
      'hisense-ua': '[0-9- +]{4,20}',
      'hisense-md':
        '[0]{1}[ ,-]{0,1}[2]{2}[ ,-]{0,1}[0-9]{2}[ ,-]{0,1}[0-9]{2}[ ,-]{0,1}[0-9]{2}|[0]{1}[ ,-]{0,1}[0-9]{3}[ ,-]{0,1}[0-9]{2}[ ,-]{0,1}[0-9]{1}[ ,-]{0,1}[0-9]{2}|[0]{1}[ ,-]{0,1}[0-9]{2}[ ,-]{0,1}[0-9]{2}[ ,-]{0,1}[0-9]{2}[ ,-]{0,1}[0-9]{2}',
      'hisense-ro': '[0-9- +]{4,20}',
      'hisense-bg': '[0-9- +]{4,20}',
      'hisense-nl': '[0-9]{3}[-]{1}[0-9]{6,7}|[0-9]{2}[-]{1}[0-9]{7,8}|[0-9]{9,10}',
      'hisense-be':
        '[0]{1}[0-9]{1}[ ]{1}[0-9]{3}[ ]{1}[0-9]{2}[ ]{1}[0-9]{2}|[0]{1}[0-9]{2}[ ]{1}[0-9]{2}[ ]{1}[0-9]{2}[ ]{1}[0-9]{2}|[0]{1}[4]{1}[0-9]{2}[ ]{1}[0-9]{2}[ ]{1}[0-9]{2}[ ]{1}[0-9]{2}',
      'hisense-at': '[0-9- +]{4,20}',
      'hisense-mk': '[0-9]{2}[ ]{1}[0-9]{7}|[0-9]{3}[ ]{1}[0-9]{6}|[0-9]{9}',
      'hisense-ee': '',
      'hisense-lt': '',
      'hisense-lv': '',
      'hisense-it': '[0-9]{10}',
      'hisense-me': '',
      'hisense-al':
        '[0]{1}[0-9]{7,9}|[0]{1}[0-9]{1,3}[ ]{1}[0-9]{2,3}[ ]{1}[0-9]{2,3}[ ]{0,1}[0-9]{0,3}|[+]{1}[3]{1}[5]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{3}[ ]{0,1}[0-9]{4}|[0]{2}[3]{1}[5]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{3}[ ]{0,1}[0-9]{4}',
      'hisense-dk': '[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}',
      'hisense-ie': '',
      'hisense-de': '[0-9]{4,14}',
      'hisense-kz': '[0-9]{3}[ ]{0,1}[0-9]{3}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}',
      'hisense-no': '[+]?[0-9]{10}|[0]{2}[0-9]{10}|[0-9]{8}',
      'hisense-se':
        '[0-9]{8,10}|[0-9]{2}[ ]{0,1}[0-9]{3}[ ]{0,1}[0-9]{2,3}[ ]{0,1}[0-9]{2}|[0-9]{3}[ ]{0,1}[0-9]{2,3}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}|[0-9]{4}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}|[0-9]{3,4}[ ]{0,1}[0-9]{3}[ ]{0,1}[0-9]{2}|[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}',
      'hisense-fi': '[0-9]{9,10}|[+]{1}[3]{1}[5]{1}[0-9]{10}',
      'hisense-gr': '',
      'hisense-fr': '[0]{0,1}[0-9]{1}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}[0-9]{2}[ ]{0,1}',
    },
    postalCode: {
      'hisense-rs': '',
      'hisense-si': '',
      'hisense-hu': '',
      'hisense-pl': '',
      'hisense-sk': '',
      'hisense-cz': '^[0-9]{3}[ ]{1}[0-9]{2}$',
      'hisense-hr': '',
      'hisense-uk':
        '^[a-zA-Z0-9]{2}[ _][a-zA-Z0-9]{3}$|^[a-zA-Z0-9]{3}[ _][a-zA-Z0-9]{3}$|^[a-zA-Z0-9]{4}[ _][a-zA-Z0-9]{3}$',
      'hisense-ba': '',
      'hisense-ua': '',
      'hisense-md': '',
      'hisense-ro': '',
      'hisense-bg': '',
      'hisense-nl': '',
      'hisense-be': '',
      'hisense-at': '',
      'hisense-mk': '^[0-9]{4}$',
      'hisense-ee': '',
      'hisense-lt': '',
      'hisense-lv': '',
      'hisense-it': '^[0-9]{5}$',
      'hisense-me': '',
      'hisense-al': '^[0-9]{4}$',
      'hisense-dk': '^[0-9]{4}$',
      'hisense-ie': '',
      'hisense-de': '',
      'hisense-kz': '^[0-9A-Z]{7}$',
      'hisense-no': '^[0-9]{4}$',
      'hisense-se': '^[0-9]{2}[ ]{0,1}[0-9]{3}$',
      'hisense-fi': '^[0-9]{5}$',
      'hisense-gr': '',
      'hisense-fr': '^[0-9]{5}$',
    },
  },
  iSiteCid: {
    'hisense-uk': '250',
  },
  tracking: {
    google: {
      tagManager: {
        id: {
          'hisense-rs': 'GTM-KJLPDNF',
          'hisense-si': 'GTM-NZN32MN',
          'hisense-hu': 'GTM-M96BJ76',
          'hisense-pl': 'GTM-WT8NVVM',
          'hisense-sk': 'GTM-KGTRB46',
          'hisense-cz': 'GTM-MWX99FQ',
          'hisense-hr': 'GTM-TK7FXLJ',
          'hisense-int': 'GTM-P67DXTH',
          'hisense-uk': 'GTM-TTTRRGB',
          'hisense-ba': 'GTM-59N3DVW',
          'hisense-ua': 'GTM-5X2WLK9',
          'hisense-md': 'GTM-MVS9BBS',
          'hisense-ro': 'GTM-N77XZBS',
          'hisense-bg': 'GTM-KW74HZK',
          'hisense-nl': 'GTM-T5XBHPW',
          'hisense-be': 'GTM-TZCNKB3',
          'hisense-at': 'GTM-KXW8M86',
          'hisense-mk': 'GTM-NPLFCZ9',
          'hisense-ee': 'GTM-PD5FH5F',
          'hisense-lt': 'GTM-MTHVMQJ',
          'hisense-lv': 'GTM-WNP87JW',
          'hisense-it': 'GTM-N2TWT89',
          'hisense-me': 'GTM-N5GNF46',
          'hisense-al': 'GTM-NCW2MFC',
          'hisense-dk': 'GTM-N27DQWJK',
          'hisense-ie': 'GTM-T7DMG59P',
          'hisense-de': 'GTM-T68VFH9R',
          'hisense-kz': 'GTM-W58CFK9S',
          'hisense-no': 'GTM-TSWQ4D3S',
          'hisense-se': 'GTM-MZFKTV5L',
          'hisense-fi': 'GTM-PJ25M2ZH',
          'hisense-gr': 'GTM-PSQZX3XJ',
          'hisense-fr': 'GTM-TFV63TD8',
        },
        server: {
          // Leave empty for default server (https://www.googletagmanager.com/), use only for Server-side Tag Manager
          // "hisense-rs": "",
          // "hisense-si": "",
          // "hisense-hu": "",
          // "hisense-pl": "",
          // "hisense-sk": "",
          // "hisense-cz": "",
          // "hisense-hr": "",
          // "hisense-int": "",
          // "hisense-uk": "",
          // "hisense-ba": "",
          // "hisense-ua": "",
          // "hisense-md": "",
          // "hisense-ro": "",
          // "hisense-bg": "",
          'hisense-nl': 'https://sgtm.hisense.com',
          'hisense-be': 'https://sgtm.hisense.com',
          // "hisense-at": "",
          // "hisense-mk": "",
          // "hisense-ee": "",
          // "hisense-lt": "",
          // "hisense-lv": "",
          // "hisense-it": "",
          // "hisense-me": "",
          // "hisense-al": "",
          // "hisense-dk": "",
          // "hisense-ie": "",
          // "hisense-de": "",
          // "hisense-kz": "",
          // "hisense-no": "",
          // "hisense-se": "",
          // "hisense-fi": "",
          // "hisense-fr": "",
        },
      },
    },
    facebook: {
      pixel: {
        id: {
          // "hisense-rs": "",
          // "hisense-si": "",
          // "hisense-hu": "",
          // "hisense-pl": "",
          // "hisense-sk": "",
          // "hisense-cz": "",
          // "hisense-hr": "",
          // "hisense-int": "",
          // "hisense-uk": "",
          // "hisense-ba": "",
          // "hisense-ua": "",
          // "hisense-md": "",
          // "hisense-ro": "",
          // "hisense-bg": "",
          // "hisense-nl": "",
          // "hisense-be": ""
          // "hisense-at": "",
          // "hisense-mk": "",
          // "hisense-ee": "",
          // "hisense-lt": "",
          // "hisense-lv": "",
          // "hisense-it": "",
          // "hisense-me": "",
          // "hisense-al": "",
          // "hisense-dk": "",
          // "hisense-ie": "",
          // "hisense-de": "",
          // "hisense-kz": "",
          // "hisense-no": "",
          // "hisense-se": "",
          // "hisense-fi": "",
          // "hisense-fr": "",
        },
      },
    },
    twitter: {
      pixel: {
        id: {
          // "hisense-rs": "",
          // "hisense-si": "",
          // "hisense-hu": "",
          // "hisense-pl": "",
          // "hisense-sk": "",
          // "hisense-cz": "",
          // "hisense-hr": "",
          // "hisense-int": "",
          'hisense-uk': 'nv269',
          // "hisense-ba": "",
          // "hisense-ua": "",
          // "hisense-md": "",
          // "hisense-ro": "",
          // "hisense-bg": "",
          // "hisense-nl": "",
          // "hisense-be": "",
          // "hisense-at": "",
          // "hisense-mk": "",
          // "hisense-ee": "",
          // "hisense-lt": "",
          // "hisense-lv": "",
          // "hisense-it": "",
          // "hisense-me": "",
          // "hisense-al": "",
          // "hisense-dk": "",
          // "hisense-ie": "",
          // "hisense-de": "",
          // "hisense-kz": "",
          // "hisense-no": "",
          // "hisense-se": "",
          // "hisense-fi": "",
          // "hisense-fr": "",
        },
      },
    },
    hotjar: {
      analytics: {
        id: {
          // "hisense-rs": "",
          // "hisense-si": "",
          // "hisense-hu": "",
          // "hisense-pl": "",
          // "hisense-sk": "",
          // "hisense-cz": "",
          // "hisense-hr": "",
          // "hisense-int": "",
          'hisense-uk': '1863201',
          // "hisense-ba": "",
          // "hisense-ua": "",
          // "hisense-md": "",
          // "hisense-ro": "",
          // "hisense-bg": "",
          // "hisense-nl": "",
          // "hisense-be": ""
          // "hisense-at": "",
          // "hisense-mk": "",
          // "hisense-ee": "",
          // "hisense-lt": "",
          // "hisense-lv": "",
          // "hisense-it": "",
          // "hisense-me": "",
          // "hisense-al": "",
          // "hisense-dk": "",
          // "hisense-ie": "",
          // "hisense-de": "",
          // "hisense-kz": "",
          // "hisense-no": "",
          // "hisense-se": "",
          // "hisense-fi": "",
          // "hisense-fr": "",
        },
      },
    },
  },
  chat: {
    liveChat: {
      'hisense-rs': false,
      'hisense-si': false,
      'hisense-hu': false,
      'hisense-pl': false,
      'hisense-sk': true,
      'hisense-cz': true,
      'hisense-hr': false,
      'hisense-int': false,
      'hisense-uk': false,
      'hisense-ba': false,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': false,
      'hisense-mk': false,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': false,
      'hisense-me': false,
      'hisense-al': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': false,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    jivoChat: {
      'hisense-rs': false,
      'hisense-si': false,
      'hisense-hu': false,
      'hisense-pl': false,
      'hisense-sk': false,
      'hisense-cz': false,
      'hisense-hr': false,
      'hisense-int': false,
      'hisense-uk': false,
      'hisense-ba': true,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': false,
      'hisense-mk': false,
      'hisense-ee': false,
      'hisense-lt': false,
      'hisense-lv': false,
      'hisense-it': false,
      'hisense-me': false,
      'hisense-al': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': false,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    freeday: {
      // Freeday channel ID
      // 'hisense-de': '6784af01-4a0b-4fec-b48f-946e8ae5e39d',
    },
  },
  bvLocale: {
    'hisense-uk': 'en_GB',
    'hisense-de': 'de_DE',
    'hisense-fr': 'fr_FR',
  },
  salesforce: {
    apiKey: '6ea901bf-f7f2-49cc-9dd7-c5d152243855-3fcec5bcb40299aaaeb3f5aaa179e1d6',
  },
  bv: {
    api: {
      'hisense-uk':
        'https://api.bazaarvoice.com/data/reviews.json?apiversion=5.4&passkey=caTfvcAoZxUX1DtyrN1JU9JvSiWXPCXyqVkfE837bPe8k&Include=Products,Comments&Stats=Reviews',
    },
  },
  showLanguageSelectorDropdown: {
    'hisense-rs': false,
    'hisense-si': false,
    'hisense-hu': false,
    'hisense-pl': false,
    'hisense-sk': false,
    'hisense-cz': false,
    'hisense-hr': false,
    'hisense-int': false,
    'hisense-uk': false,
    'hisense-ba': false,
    'hisense-ua': false,
    'hisense-md': true,
    'hisense-ro': false,
    'hisense-bg': false,
    'hisense-nl': true,
    'hisense-be': true,
    'hisense-at': false,
    'hisense-mk': false,
    'hisense-ee': false,
    'hisense-lt': false,
    'hisense-lv': false,
    'hisense-it': false,
    'hisense-me': false,
    'hisense-al': false,
    'hisense-dk': false,
    'hisense-ie': false,
    'hisense-de': false,
    'hisense-kz': true,
    'hisense-no': false,
    'hisense-se': false,
    'hisense-fi': false,
    'hisense-gr': false,
    'hisense-fr': false,
  },
  reCaptchaV3: {
    siteKey: {
      'hisense-rs': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-si': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-hu': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-pl': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-sk': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-cz': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-hr': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-int': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-uk': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-ba': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-ua': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-md': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-ro': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-bg': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-nl': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-be': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-at': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-mk': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-ee': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-lt': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-lv': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-it': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-me': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-al': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-dk': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-ie': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-de': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-kz': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-no': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-se': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-fi': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-gr': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
      'hisense-fr': '6Lc2GIMpAAAAAH8t2IXUrkTYEgusEgvVBPvGtP-y',
    },
  },
  googleSearchConsole: {
    'hisense-rs': '',
    'hisense-si': '',
    'hisense-hu': '',
    'hisense-pl': '',
    'hisense-sk': '',
    'hisense-cz': '',
    'hisense-hr': '',
    'hisense-int': '',
    'hisense-uk': '',
    'hisense-ba': '',
    'hisense-ua': '',
    'hisense-md': '',
    'hisense-ro': '',
    'hisense-bg': '',
    'hisense-nl': '',
    'hisense-be': '',
    'hisense-at': '',
    'hisense-mk': '',
    'hisense-ee': '',
    'hisense-lt': '',
    'hisense-lv': '',
    'hisense-it': '',
    'hisense-me': '',
    'hisense-al': '',
    'hisense-dk': '',
    'hisense-ie': '',
    'hisense-de': 'Se8S2fC4oQJ2xD--8lMZYVZvgJYJVRUNrxeqAmtqISc',
    'hisense-kz': '',
    'hisense-no': '',
    'hisense-se': '',
    'hisense-fi': '',
    'hisense-gr': '',
    'hisense-fr': '',
  },
  oldApplianceRemoval: {
    show: {
      'hisense-rs': false,
      'hisense-si': true,
      'hisense-hu': true,
      'hisense-pl': false,
      'hisense-sk': false,
      'hisense-cz': false,
      'hisense-hr': false,
      'hisense-int': false,
      'hisense-uk': false,
      'hisense-ba': true,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': false,
      'hisense-mk': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': false,
      'hisense-kz': false,
      'hisense-no': false,
      'hisense-se': false,
      'hisense-fi': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    conditionalDisplay: {
      'hisense-rs': false,
      'hisense-si': false,
      'hisense-hu': false,
      'hisense-pl': false,
      'hisense-sk': false,
      'hisense-cz': false,
      'hisense-hr': false,
      'hisense-int': false,
      'hisense-uk': false,
      'hisense-ba': false,
      'hisense-ua': false,
      'hisense-md': false,
      'hisense-ro': false,
      'hisense-bg': false,
      'hisense-nl': false,
      'hisense-be': false,
      'hisense-at': false,
      'hisense-mk': false,
      'hisense-dk': false,
      'hisense-ie': false,
      'hisense-de': true,
      'hisense-kz': false,
      'hisense-gr': false,
      'hisense-fr': false,
    },
    deliveryModeCode: {
      'hisense-rs': '',
      'hisense-si': '',
      'hisense-hu': '',
      'hisense-pl': '',
      'hisense-sk': '',
      'hisense-cz': '',
      'hisense-hr': '',
      'hisense-int': '',
      'hisense-uk': '',
      'hisense-ba': '',
      'hisense-ua': '',
      'hisense-md': '',
      'hisense-ro': '',
      'hisense-bg': '',
      'hisense-nl': '',
      'hisense-be': '',
      'hisense-at': '',
      'hisense-mk': '',
      'hisense-dk': '',
      'hisense-ie': '',
      'hisense-de': 'hisense-mda',
      'hisense-kz': '',
      'hisense-gr': '',
      'hisense-fr': '',
    },
  },
  iAdvize: {
    'hisense-fr': 8905,
  },
};
